import React from "react";
import { useTranslation } from "react-i18next";
import aboutData from "../data/aboutData";

export default function AboutUs() {
  const { t } = useTranslation();

  return (
    <>
      <section className="about-landing">
        <div className="container h-full relative z-10 text-white flex flex-col items-center justify-center gap-[6px]">
          <div className="text-[50px] font-bold">{t("About Us")}</div>
          <div className="w-100 text-[20px] w-1/2 text-center">
            {t(
              "Learn more about MA Partners Chartered Accountants and our commitment to excellence"
            )}
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center justify-center gap-[8px] text-center mb-12">
            <h2 className="text-[35px] font-bold text-[#3896BE] capitalize">
              {t("Who We Are")}
            </h2>
            <div className="flex flex-col gap-[3px] justify-center items-center">
              <span className="bg-[#3896BE] flex w-[150px] h-[4px]"></span>
              <span className="bg-[#3896BE] flex w-[250px] h-[4px]"></span>
              <span className="bg-[#3896BE] flex w-[150px] h-[4px]"></span>
            </div>
          </div>

          <div className="flex items-center gap-5 flex-col md:flex-row">
            <div className="w-full md:w-[48%]">
              <div className="text-[25px] font-bold">
                {t("MA Partners Chartered Accountants")}
              </div>
              <p className="text-lg text-[#404040]">
                {t(
                  "MA Partners Chartered Accountants is a registered professional consultancy firm and a Certified Chartered Accountants and Registered Auditors firm, regulated by the Ministry of Economy, United Arab Emirates. Established in 2018 and headquartered in Abu Dhabi, we offer a comprehensive range of financial and business services including audit, tax, forensic accounting, ICV certification, business advisory, and liquidation."
                )}
              </p>
            </div>
            <div className="w-full md:w-[48%]">
              <img
                className="w-full h-full object-cover rounded-lg"
                src={require("../../assets/images/image-about-us.svg").default}
                alt={t("About Us Image")}
              />
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-[40px]">
        <div className="container mx-auto px-4">
          <div className="flex flex-col items-center justify-center gap-[8px] text-center mb-12">
            <h2 className="text-[35px] font-bold text-[#3896BE] capitalize">
              {t("What We Do")}
            </h2>
            <div className="flex flex-col gap-[3px] justify-center items-center">
              <span className="bg-[#3896BE] flex w-[150px] h-[4px]"></span>
              <span className="bg-[#3896BE] flex w-[250px] h-[4px]"></span>
              <span className="bg-[#3896BE] flex w-[150px] h-[4px]"></span>
            </div>
          </div>

          <div className="flex flex-col items-center gap-5">
            <div className="w-full flex flex-col gap-[5px] justify-center items-center text-center">
              <p className="text-lg text-[#404040]">
                {t(
                  "We are more than just a service provider; we are your strategic partner. We work closely with you to understand your vision and challenges, co-creating a customized solution that not only meets your needs but helps you thrive. Our collaborative approach ensures we are aligned every step of the way."
                )}
              </p>
            </div>
            <div className="w-full">
              <div className="flex flex-wrap justify-between gap-[8px]">
                {aboutData.map((item) => (
                  <div
                    key={item.id}
                    className="w-full sm:w-[48%] lg:w-[30%] flex flex-col items-center gap-[8px] text-center bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow"
                  >
                    <div className="w-12 h-12 flex items-center justify-center rounded-full bg-gradient-to-r from-[#3896BE] to-[#1A4558]">
                      <img
                        src={item.icon}
                        alt={`${t(item.title)} icon`}
                        className="w-[30px] h-[30px]"
                      />
                    </div>
                    <h3 className="text-xl font-semibold text-[#3896BE] mb-2">
                      {t(item.title)}
                    </h3>
                    <p className="text-sm text-gray-500">{t(item.text)}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="relative py-[60px] bg-gray-50">
        <div className="container mx-auto px-4">

          <div className="flex flex-col items-center justify-center gap-[8px] text-center mb-16">
            <h2 className="text-[35px] font-bold text-[#3896BE] capitalize">
              {t("Main Principles")}
            </h2>
            <div className="flex flex-col gap-[3px] justify-center items-center">
              <span className="bg-[#3896BE] flex w-[150px] h-[4px] rounded-full"></span>
              <span className="bg-[#3896BE] flex w-[250px] h-[4px] rounded-full"></span>
              <span className="bg-[#3896BE] flex w-[150px] h-[4px] rounded-full"></span>
            </div>
          </div>

          <div className="flex items-center gap-10 flex-col md:flex-row mb-16">
            {/* Left Image */}
            <div className="w-full md:w-[45%]">
              <img
                className="w-full h-full object-cover rounded-2xl shadow-lg"
                src={
                  require("../../assets/images/image-about-left.svg").default
                }
                alt={t("Main Principles Image")}
              />
            </div>

            {/* Right Text */}
            <div className="w-full md:w-[55%] space-y-8">
              {/* Intro */}
              <div>
                <h3 className="text-[25px] font-bold text-[#222] mb-2">
                  {t("MA Partners Chartered Accountants")}
                </h3>
                <p className="text-lg text-[#404040] leading-relaxed">
                  {t(
                    "MA Partners Chartered Accountants is a registered professional consultancy firm and a Certified Chartered Accountants and Registered Auditors firm, regulated by the Ministry of Economy, United Arab Emirates. Established in 2018 and headquartered in Abu Dhabi, we offer a comprehensive range of financial and business services including audit, tax, forensic accounting, ICV certification, business advisory, and liquidation."
                  )}
                </p>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
            {[
              {
                title: "Client-Centric Approach",
                desc: "Your success is our top priority and the driving force behind everything we do. We listen closely to your needs to build a partnership that delivers real value.",
              },
              {
                title: "Commitment to Excellence",
                desc: "We hold ourselves to the highest standards, ensuring exceptional quality in every detail. Our dedication to excellence is what sets us apart and defines our work.",
              },
              {
                title: "Unwavering Integrity",
                desc: "We operate with complete honesty, transparency, and ethical conduct. You can trust us to always do the right thing and be true to our word.",
              },
              {
                title: "Innovation & Growth",
                desc: "We are constantly learning and exploring new solutions to stay ahead of the curve. Our innovative mindset allows us to solve complex challenges and create lasting impact.",
              },
              {
                title: "Collaborative Partnership",
                desc: "We believe that the best results come from working together. Our team partners with you to co-create solutions and achieve shared goals.",
              },
              {
                title: "Accountability",
                desc: "We take full ownership of our work and stand behind our commitments.",
              },
            ].map((item, index) => (
              <div
                key={index}
                className="bg-white shadow-md hover:shadow-xl transition-shadow rounded-xl p-6 border border-gray-100"
              >
                <h4 className="text-lg font-semibold text-[#3896BE] mb-2">
                  {t(item.title)}
                </h4>
                <p className="text-gray-600 text-sm leading-relaxed">
                  {t(item.desc)}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </>
  );
}
